import React from 'react';

import Layout from 'layouts/Layout';
import Loading from './Loading';

const LoadingLayout = () => <Layout component={Loading} />;

export default LoadingLayout;
